<template>
    <div class="shorting-filter" v-if="shortingParam != null" v-click-outside="onClickOutside">
        <div class="mobile-filter-header" v-if="isMobileChecker">
            <h2><span>Сортировать</span></h2>
            <a href="#" class="close-link" @click.prevent="closeMobileShorting"><svgIcon name="close" class="icon-svg"/></a>
        </div>
        <div class="dropwdown-shorting-select">
            <div class="drop-filter-name" :class="{'open' : open_drop}">
                <div class="short-icon">
                    <svgIcon name="shorting-up" class="icon-up" v-if="shortingParam.type == 'ascending'"/>
                    <svgIcon name="shorting-down" class="icon-down" v-if="shortingParam.type == 'descending'"/>
                </div>
                <a href="#" @click.prevent="open_drop = !open_drop">{{shortingParam.name}}</a>
                <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
            </div>
            <div class="dropdown-menu" :class="{'open' : open_drop}">
                <div class="drop-checkbox-container">
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.price_up.name" :value="filterCMSparams.shorting_names.price_up.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.price_up)"> 
                        <label :for="filterCMSparams.shorting_names.price_up.name">{{filterCMSparams.shorting_names.price_up.name}}</label>
                    </div>
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.price_down.name" :value="filterCMSparams.shorting_names.price_down.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.price_down)"> 
                        <label :for="filterCMSparams.shorting_names.price_down.name">{{filterCMSparams.shorting_names.price_down.name}}</label>
                    </div>
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.room_up.name" :value="filterCMSparams.shorting_names.room_up.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.room_up)"> 
                        <label :for="filterCMSparams.shorting_names.room_up.name">{{filterCMSparams.shorting_names.room_up.name}}</label>
                    </div>
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.room_down.name" :value="filterCMSparams.shorting_names.room_down.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.room_down)"> 
                        <label :for="filterCMSparams.shorting_names.room_down.name">{{filterCMSparams.shorting_names.room_down.name}}</label>
                    </div>
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.size_up.name" :value="filterCMSparams.shorting_names.size_up.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.size_up)"> 
                        <label :for="filterCMSparams.shorting_names.size_up.name">{{filterCMSparams.shorting_names.size_up.name}}</label>
                    </div>
                    <div class="item-R">
                        <input type="radio" :id="filterCMSparams.shorting_names.size_down.name" :value="filterCMSparams.shorting_names.size_down.name" v-model="shortingParam.name" @click="updateShortParams(filterCMSparams.shorting_names.size_down)"> 
                        <label :for="filterCMSparams.shorting_names.size_down.name">{{filterCMSparams.shorting_names.size_down.name}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    // import simplebar from 'simplebar-vue';
    // import 'simplebar-vue/dist/simplebar.min.css';
    import {mapGetters} from 'vuex'
    export default {
        name: 'shorting-filter',
        components: {
            svgIcon,
            // simplebar,
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                open_drop: false,
            }
        },
        computed: mapGetters({
            flatsItems: 'loadFlatsItems',
            filterCMSparams: 'loadFilterCMSparams',
            shortingParam: 'loadFlatsShortingParams',
            isOpenShortingMobile: 'loadOpenFlatsMobileShorting',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            onClickOutside() {
                this.open_drop = false;
            },
            updateShortParams(item) {
                this.open_drop = false;
                this.$store.commit('setFlatsShortingParams', item);
                this.$store.commit('setFlatsItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.flatsItems});
                this.closeMobileShorting();
            },
            closeMobileShorting() {
                this.$store.commit('OpenFlatsMobileShorting', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
                document.getElementById('footer').classList.remove('hideMobile');
            },
        },
        beforeCreate() {
        },
        created () {
            this.$store.commit('setFlatsShortingParams', this.filterCMSparams.shorting_names.price_up);
            this.$store.commit('setFlatsItemsByShorting', {'shorting_params' : this.shortingParam, 'items' : this.flatsItems});
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/shorting-filter/shorting-filter.scss';
    @import '@/styles/components/filters/shorting-filter/respond/shorting-filter-respond.scss';
    // @import '@/styles/components/filters/parking-filter/respond/parking-filter-respond.scss';
    // @import '@/styles/components/filters/sales-projects/respond/sales-filter-respond.scss';
</style>